import api from './api';

export const householdService = {
  getAllHouseholds: async () => {
    const response = await api.get('/households');
    return response.data;
  },

  getHouseholdById: async (id) => {
    const response = await api.get(`/households/${id}`);
    return response.data;
  },

  getHouseholdDetailById: async (id) => {
    const response = await api.get(`/households/${id}/detail`);
    return response.data;
  },

  getHouseholdByCode: async (code) => {
    const response = await api.get(`/households/code/${code}`);
    return response.data;
  },

  createHousehold: async (householdData) => {
    const response = await api.post('/households', householdData);
    return response.data;
  },

  updateHousehold: async (id, householdData) => {
    const response = await api.put(`/households/${id}`, householdData);
    return response.data;
  },

  regenerateHouseholdCode: async (id) => {
    const response = await api.put(`/households/${id}/regenerate-code`);
    return response.data;
  },

  deleteHousehold: async (id) => {
    const response = await api.delete(`/households/${id}`);
    return response.data;
  },

  searchHouseholds: async (searchTerm) => {
    const response = await api.get(`/households/search?q=${searchTerm}`);
    return response.data;
  },

  getHouseholdsByUser: async (userId) => {
    const response = await api.get(`/households/user/${userId}`);
    return response.data;
  },

  addUserToHousehold: async (householdId, userId) => {
    const response = await api.post(`/households/${householdId}/users/${userId}`);
    return response.data;
  },

  removeUserFromHousehold: async (householdId, userId) => {
    const response = await api.delete(`/households/${householdId}/users/${userId}`);
    return response.data;
  },

  updatePrimaryCaregiver: async (householdId, caregiverId) => {
    const response = await api.put(`/households/${householdId}/primary-caregiver/${caregiverId}`);
    return response.data;
  }
}; 